import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../agency/AgencyPolygonCreation.css";
import { Handler } from "leaflet";


///Create this to ur component
///Modal setting
// const [modalToggle, setModalToggle] = useState({
//     modalSuccess: false,
//     modalDenied: false,
//     modalErr: false,
//     modalwait: false,
//   });
//   const [textBody,setTextBody] = useState()
//   const handleClose_Modal = (close) => {
//     setModalToggle({...modalToggle,modalSuccess:close,modalDenied:close,modalErr:close,modalwait:close})
//   };

/// <Wating_Modal modalwaiting={modalToggle.modalwait} modalErr={modalToggle.modalErr} modalSuccess={modalToggle.modalSuccess} modalDenied={modalToggle.modalDenied} 
/// textBody={textBody} getHandle={handleclose}/>

///Static Modal Asset 
/// 1. LoadingModal || waiting anything ==> can got message by textBody
/// 2. SuccessModal
/// 3. Denied || Cancel Modal
/// 4. ErrMessage Modal    ==> can got message by textBody

const Static_modal = (props) => {
    const [toggle, setToggle] = useState(true)
    const [text, setText] = useState("กรุณารอสักครู่")
    const handleClose = () => {
        setToggle(false)
        props.getHandle(false)
    }

    ///Control toggle
    useEffect(() => {
        setToggle(true)
    }, [props.modalwaiting, props.modalErr, props.modalSuccess, props.modalDenied])

    useEffect(() => {
        if (props.textBody !== undefined) {
            setText(props.textBody)
        }
    }, [props.textBody])
    return (
        <>
            {/* Modal Waiting */}
            <Modal
                size="sm"
                show={props.modalwaiting && toggle}
                onHide={handleClose}
                centered

            >
                <Modal.Header style={{ width: "300px", height: "250px", justifyContent: "center", alignItems: "center", display: "flex" }}>
                    <Modal.Body>
                        <div className="container-modal-loding"   >
                            <div className="flex">
                                <div className="loader" />
                            </div>
                            <div className="load-text">กรุณารอสักครู่</div>
                        </div>
                    </Modal.Body>
                </Modal.Header>
            </Modal>
            {/* action success */}
            <Modal
                size="sm"
                show={props.modalSuccess && toggle}
                onHide={handleClose}
                centered
            >
                <Modal.Body style={{ width: "300px", height: "250px" }}>
                    <div className="success-checkmark">
                        <div className="check-icon">
                            <span className="icon-line line-tip" />
                            <span className="icon-line line-long" />
                            <div className="icon-circle"></div>
                            <div className="icon-fix"></div>
                        </div>
                    </div>

                    <h3 className="text-center text-success">สำเร็จ!</h3>
                </Modal.Body>
            </Modal>
            {/* action denied */}

            <Modal
                size="sm"
                show={props.modalDenied && toggle}
                onHide={handleClose}
                centered
            >
                <Modal.Body style={{ width: "300px", height: "250px" }}>
                    <div className="wrap">
                        <svg
                            width="100"
                            height="100"
                            viewBox="0 0 447 447"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="cancel-mark">
                                <rect width="447" height="447" fill="white" />
                                <circle
                                    id="Circle"
                                    cx="223.5"
                                    cy="223.5"
                                    r="210.5"
                                    stroke="#9F2B2B"
                                    stroke-width="26"
                                />
                                <g id="X-mark">
                                    <line
                                        id="Line"
                                        x1="119.385"
                                        y1="115.92"
                                        x2="330.92"
                                        y2="325.615"
                                        stroke="#9F2B2B"
                                        stroke-width="26"
                                        stroke-linecap="round"
                                    />
                                    <line
                                        id="Line"
                                        x1="331.809"
                                        y1="119.384"
                                        x2="119.384"
                                        y2="328.178"
                                        stroke="#9F2B2B"
                                        stroke-width="26"
                                        stroke-linecap="round"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-center text-danger">ยกเลิก!</h3>
                </Modal.Body>
            </Modal>

            {/* action err */}
            <Modal show={props.modalErr} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title><h4>ตรวจสอบข้อมูล</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body className="font-cen">{text}</Modal.Body>
                <Modal.Footer>
                    <button className="custom-btn btnSave" onClick={handleClose}>
                        ยืนยัน
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Static_modal;
